export default "__VITE_ASSET__BupP51fx__"